import { ActionHandler } from 'action-handler';

export const STATE_PROP = 'grantedPermissions';

export default new ActionHandler({
  name: 'save_permissions',
  stateProp: STATE_PROP,
  defaultState: {
    [STATE_PROP]: {}
  },
  handler: ({ appId, grantedPermissions }) => ({
    appId,
    grantedPermissions
  }),
  reduce: (state, { appId, grantedPermissions }) => ({
    [STATE_PROP]: {
      ...state[STATE_PROP],
      [appId]: grantedPermissions
    }
  })
});
